import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routes, routeFor } from 'src/core/constants/routes';

import { NavLink } from '../NavLink/NavLink';

type Props = {
  company: {
    id: string;
  };
};

export const TravelLink = ({ company }: Props) => {
  const { t } = useTranslation('global');

  return (
    <NavLink
      href={routeFor(routes.TRAVEL_HOMEPAGE.path, {
        company: company.id,
      })}
      iconName="plane"
      activePaths={[routes.TRAVEL_HOMEPAGE.path]}
    >
      {t('misc.travelTitle')}
    </NavLink>
  );
};
